<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <div class="titulo my-4 px-4">
                    <h1 class="font-weight-bold" :class="esMovil ? 'text-h6' : 'text-h5'">
                        {{ titulo }}
                    </h1>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="esListaIndiacoresVacio">
            <v-col>
                <v-card>
                    <v-card-text v-if="consentimientoCookies">
                        {{ textoSinFavoritos }}
                        <router-link :to="{ name: 'listado-indicadores' }">
                            {{ textoEnlaceSinFavoritos }}
                        </router-link>
                    </v-card-text>
                    <v-card-text v-else>
                        {{ textoSinConsentimientoCookies }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <ListaIndicadores :listaIndicadores="listaIndicadores"> </ListaIndicadores>
        </v-row>
    </v-container>
</template>
<script>
import ListaIndicadores from "@components/ListaIndicadores.vue";
import IndicadoresService from "@services/IndicadoresService.js";

export default {
    name: "favoritos",
    components: {
        ListaIndicadores,
    },
    data: function () {
        return {
            listaIndicadores: [],
            titulo: this.$t("favoritos.texto.titulo"),
            textoSinFavoritos: this.$t("favoritos.texto.sin-favoritos"),
            textoEnlaceSinFavoritos: this.$t("favoritos.enlace.sin-favoritos"),
            textoSinConsentimientoCookies: this.$t("favoritos.texto.sin-consentimiento"),
            consentimientoCookies: false,
        };
    },
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        esListaIndiacoresVacio() {
            return this.listaIndicadores.length == 0;
        },
    },
    methods: {
        obtenerListaFavoritos() {
            let listaFavoritos = localStorage.listaFavoritos
                ? JSON.parse(localStorage.listaFavoritos)
                : [];

            if (listaFavoritos.length > 0) {
                let params = { listaFavoritos: listaFavoritos };
                IndicadoresService.getFavoritos(params).then((response) => {
                    this.listaIndicadores = response.data;
                });
            }
        },
        getConsentimientoCookies() {
            return document.cookie.split("; ").reduce((r, v) => {
                const parts = v.split("=");
                return parts[0] === this.nombreCookie
                    ? Boolean(Number(decodeURIComponent(parts[1])))
                    : r;
            }, false);
        },
    },

    mounted() {
        this.consentimientoCookies = this.getConsentimientoCookies();
        if (this.consentimientoCookies) {
            this.obtenerListaFavoritos();
        }
    },
};
</script>
